<template>
	<main id="container" class="page-container event-lottery-page">
		<div class="page-content">
			<div class="container">
				<section>
					<div class="conTitArea line">
						<h2>이벤트 안내</h2>
					</div>

					<div class="detailCon">
						<div class="tab tabFunc">
							<div class="tabMenu mScrollArea">
								<ul class="lineBtn">
									<li :class="{ curr: activeTab === 1 }">
										<a href="javascript:void(0);" @click.prevent="activeTab = 1">상생소비복권</a>
									</li>
								</ul>
							</div>

							<div class="tabCon">
								<div v-show="activeTab === 1" style="display: block">
									<h3 class="hide">상생소비복권</h3>
									<div class="lotteryTicketEventContents">
										<picture>
											<img
												src="/images/img-event-tab01.png"
												alt="상생소비복권 이벤트 안내"
											/>
										</picture>

										<!-- PC용 버튼 (모바일에서 숨김) -->
										<div class="lotteryAppLinkBtn pc-only">
											<a
												href="https://play.google.com/store/apps/details?id=com.komsco.kpay"
												class="androidBtn"
												target="_blank"
												rel="noopener noreferrer"
											>
												<img src="/images/android-icon.png" alt="안드로이드 아이콘" />
												<div class="rightLinkText">
													<p>디지털온누리 앱</p>
													<p>
														안드로이드 다운로드
														<span>
															<img src="/images/app-arrow-right-icon.png" alt="화살표 아이콘" />
														</span>
													</p>
												</div>
											</a>

											<a
												href="https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450"
												class="iosBtn"
												target="_blank"
												rel="noopener noreferrer"
											>
												<img src="/images/ios-icon.png" alt="애플 iOS 아이콘" />
												<div class="rightLinkText">
													<p>디지털온누리 앱</p>
													<p>
														iOS다운로드
														<span>
															<img src="/images/app-arrow-right-icon.png" alt="화살표 아이콘" />
														</span>
													</p>
												</div>
											</a>
										</div>

										<!-- 모바일용 핫스팟 (이미지 위 투명 클릭 영역) -->
										<a
											href="https://play.google.com/store/apps/details?id=com.komsco.kpay"
											class="hotspot android-hotspot mobile-only"
											target="_blank"
											rel="noopener noreferrer"
											aria-label="안드로이드 다운로드"
										></a>

										<a
											href="https://apps.apple.com/kr/app/%EB%94%94%EC%A7%80%ED%84%B8%EC%98%A8%EB%88%84%EB%A6%AC/id6738372450"
											class="hotspot ios-hotspot mobile-only"
											target="_blank"
											rel="noopener noreferrer"
											aria-label="iOS 다운로드"
										></a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</main>
</template>

<script>
export default {
	name: 'EventLottery',
	data() {
		return {
			activeTab: 1,
		};
	},
	mounted() {
		window.scrollTo(0, 0);
	},
};
</script>

<style scoped>
.page-container.event-lottery-page {
	background: #ffffff !important;
	background-image: none !important;
}

.event-lottery-page .page-content {
	margin-top: 0 !important;
	margin-bottom: 60px !important;
	padding-top: 20px !important;
	padding-bottom: 60px !important;
	background: #ffffff !important;
	background-image: none !important;
}

.event-lottery-page .container {
	max-width: 1640px;
	margin: 0 auto;
	padding: 0 20px;
}

.conTitArea {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 40px 0 30px;
}

.conTitArea.line {
	border-bottom: 2px solid #000;
}

.conTitArea h2 {
	font-weight: 700;
	font-size: 34px;
	color: #000;
	margin: 0;
}

.detailCon {
	margin: 40px auto 0;
}

.tabMenu.mScrollArea {
	width: 100%;
	overflow-x: auto;
}

.tabMenu ul {
	display: flex;
	align-items: center;
	gap: 10px;
	list-style: none;
	padding: 0;
	margin: 0;
}

.tabMenu .lineBtn {
	justify-content: flex-start;
	gap: 20px;
}

.tabMenu .lineBtn li {
	min-width: 103px;
	background: #fff;
	border-radius: 8px;
	border: 1px solid #11194f;
	overflow: hidden;
}

.tabMenu .lineBtn li a {
	display: block;
	padding: 13px 24px;
	width: 100%;
	border: none;
	font-weight: 400;
	color: #11194f;
	font-size: 20px;
	text-align: center;
	letter-spacing: -1.2px;
	text-decoration: none;
}

.tabMenu ul.lineBtn li.curr a,
.tabMenu ul.lineBtn li a:hover {
	background: #252c5d;
	color: #fff !important;
	font-weight: 700;
}

.tabCon {
	padding: 30px 0 100px 0;
}

.lotteryTicketEventContents {
	position: relative;
	width: 100%;
}

.lotteryTicketEventContents picture,
.lotteryTicketEventContents picture > img {
	display: block;
	width: 100%;
	height: auto;
}

/* PC 버튼 */
.lotteryAppLinkBtn {
	position: absolute;
	bottom: 2.4%;
	left: 50%;
	transform: translateX(-50%);
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 20px;
	width: 92%;
	max-width: 1500px;
}

.androidBtn,
.iosBtn {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 16px;
	width: calc(50% - 10px);
	max-width: 700px;
	height: 140px;
	border-radius: 16px;
	text-decoration: none;
	color: #fff !important;
	border: none;
	box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	transition: transform 0.2s ease, box-shadow 0.2s ease;
	padding: 0 20px;
	box-sizing: border-box;
}

.androidBtn {
	background-color: #17a769;
}

.iosBtn {
	background: linear-gradient(180deg, #17bff9 0%, #1a78e9 100%);
}

.androidBtn:hover,
.iosBtn:hover {
	transform: translateY(-3px);
	box-shadow: 0 8px 25px rgba(0, 0, 0, 0.25);
}

.androidBtn > img {
	width: 90px;
	height: auto;
	flex-shrink: 0;
}

.iosBtn > img {
	width: 110px;
	height: auto;
	flex-shrink: 0;
}

.rightLinkText {
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: center;
}

.lotteryAppLinkBtn p:nth-child(1) {
	font-family: "Gmarket Sans", "Pretendard", -apple-system, sans-serif;
	font-size: 28px;
	font-weight: 500;
	color: #fff;
	margin: 0;
	line-height: 1.2;
}

.lotteryAppLinkBtn p:nth-child(2) {
	font-family: "Gmarket Sans", "Pretendard", -apple-system, sans-serif;
	font-size: 42px;
	font-weight: 700;
	color: #fff;
	display: flex;
	align-items: center;
	gap: 6px;
	line-height: 1.3;
	margin: 0;
}

.lotteryAppLinkBtn p:nth-child(2) span {
	margin-left: 12px;
	display: inline-flex;
	align-items: center;
}

.lotteryAppLinkBtn p:nth-child(2) span img {
	height: 36px;
	width: auto;
}

/* 모바일 핫스팟 (기본 숨김) */
.mobile-only {
	display: none;
}

.hotspot {
	position: absolute;
	background: transparent;
	z-index: 2;
	/* 디버깅용으로 잠시 보이게 하려면 아래 주석 해제 */
	/* background: rgba(255, 0, 0, 0.3); */
}

.hide {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	border: 0;
}

@media (max-width: 1400px) {
	.androidBtn,
	.iosBtn {
		height: 110px;
		gap: 12px;
	}
	.androidBtn > img {
		width: 70px;
	}
	.iosBtn > img {
		width: 85px;
	}
	.lotteryAppLinkBtn p:nth-child(1) {
		font-size: 22px;
	}
	.lotteryAppLinkBtn p:nth-child(2) {
		font-size: 32px;
	}
	.lotteryAppLinkBtn p:nth-child(2) span img {
		height: 26px;
	}
}

@media (max-width: 1024px) {
	.lotteryAppLinkBtn {
		bottom: 2.2%;
		gap: 12px;
	}
	.androidBtn,
	.iosBtn {
		height: 80px;
		gap: 10px;
		border-radius: 12px;
		padding: 0 12px;
	}
	.androidBtn > img {
		width: 48px;
	}
	.iosBtn > img {
		width: 58px;
	}
	.lotteryAppLinkBtn p:nth-child(1) {
		font-size: 16px;
	}
	.lotteryAppLinkBtn p:nth-child(2) {
		font-size: 22px;
	}
	.lotteryAppLinkBtn p:nth-child(2) span {
		margin-left: 6px;
	}
	.lotteryAppLinkBtn p:nth-child(2) span img {
		height: 18px;
	}
}

@media (max-width: 768px) {
	.conTitArea {
		padding: 30px 0 20px;
	}
	.conTitArea h2 {
		font-size: 26px;
	}
	.detailCon {
		margin-top: 24px;
	}
	.tabMenu .lineBtn li a {
		padding: 10px 18px;
		font-size: 16px;
	}
	.tabCon {
		padding: 20px 0 60px 0;
	}

	/* PC 버튼 숨기고 핫스팟 표시 */
	.pc-only {
		display: none !important;
	}
	.mobile-only {
		display: block;
	}

	/* 모바일 핫스팟 위치 (이미지 안 버튼 위치에 맞게 조정) */
	.android-hotspot {
		left: 6%;
		bottom: 6.5%;
		width: 42%;
		height: 11%;
	}

	.ios-hotspot {
		right: 6%;
		bottom: 6.5%;
		width: 42%;
		height: 11%;
	}
}

@media (max-width: 480px) {
	.android-hotspot {
		left: 6%;
		bottom: 1%;
		width: 43%;
		height: 5%;
	}
	.ios-hotspot {
		right: 7%;
		bottom: 1%;
		width: 43%;
		height: 5%;
	}
}
</style>